// ── SCROLL REVEAL ──
document.addEventListener('DOMContentLoaded', function() {
  var obs = new IntersectionObserver(function(entries) {
    entries.forEach(function(e) {
      if (e.isIntersecting) {
        e.target.classList.add('in');
        obs.unobserve(e.target);
      }
    });
  }, { threshold: 0.08 });
  document.querySelectorAll('.reveal').forEach(function(el) { obs.observe(el); });

  // Close mobile menu on link click
  document.querySelectorAll('.mobile-menu a').forEach(function(a) {
    a.addEventListener('click', function() {
      document.querySelector('.mobile-menu').classList.remove('open');
    });
  });
});

// ── INTERCEPT CART LINKS → OPEN DRAWER ──
document.addEventListener('DOMContentLoaded', function() {
  document.querySelectorAll('.nav-cart, a[href="/cart"]').forEach(function(link) {
    link.addEventListener('click', function(e) {
      if (!this.classList.contains('cart-drawer-view-cart')) {
        e.preventDefault();
        if (typeof openCartDrawer === 'function') openCartDrawer();
        else window.location.href = '/cart';
      }
    });
  });
});
